// Галочка выбора строки реестра. Обёртка над примитивом дизайн-системы, которая добавляет
// ровно одно: подпись для чтения с экрана и увеличенную область нажатия.
//
// Область нажатия важнее, чем кажется: галочка 20 точек в строке высотой 44 — это промах
// через раз, а промах здесь означает открытую карточку вместо отметки, то есть уход с экрана
// вместе с уже набранным выделением.

import * as Checkbox from '@/shared/ui/checkbox';

export interface RowCheckboxProps {
  id: string;
  /** Кого именно выбираем: «Выбрать: Старцев Иван Петрович». */
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function RowCheckbox({ id, label, checked, onCheckedChange }: RowCheckboxProps) {
  return (
    // 32 точки под мышь и 44 под палец: промах здесь стоит не «нажал не туда», а открытой
    // карточки вместо отметки — то есть ухода с экрана вместе с уже набранным выделением.
    <span className='flex size-8 items-center justify-center тач:size-11'>
      <Checkbox.Root
        id={id}
        aria-label={label}
        checked={checked}
        onCheckedChange={(next) => onCheckedChange(next === true)}
      />
    </span>
  );
}
